// @ts-nocheck
/* Port of TagChip.js (14L). BYTE-IDENTICAL. */
import React from 'react';

const TagChip = ({ tag }: any) => (
  <span className="rc-tag">
    <span
      className="rc-tag__dot"
      style={{ background: tag?.color || '#94a3b8' }}
    />
    {tag?.name}
  </span>
);

export default TagChip;
